import { Controller } from '@hotwired/stimulus';
import Rails from '@rails/ujs';

export default class extends Controller {
  static targets = ['emptyTemplate', 'leftPane', 'rightPane'];

  new(event) {
    this.request({
      url: event.params.url,
      type: 'get',
      success: (data) => {
        this.updatePanes(data);
        setTimeout(() => this.focusFirstInput(), 100);
      }
    });
  }

  edit(event) {
    this.request({
      url: event.params.url,
      type: 'get',
      success: (data) => {
        this.updatePanes(data);
      }
    });
  }

  newSubUnit(event) {
    this.request({
      url: event.params.url,
      type: 'get',
      success: (data) => {
        this.updatePanes(data);
        setTimeout(() => this.focusFirstInput(), 100);
      }
    });
  }

  create(event) {
    event.preventDefault();
    event.stopPropagation();

    const form = event.target.closest('form');
    if (!form) return;

    const input = form.querySelector('input[type=text]');

    this.request({
      url: form.action,
      data: new FormData(form),
      type: 'post',
      success: (data) => {
        this.updatePanes(data);
      }
    });
  }

  update(event) {
    event.preventDefault();
    event.stopPropagation();

    const form = event.target.closest('form');
    if (!form) return;

    const input = form.querySelector('input[type=text]');

    this.request({
      url: form.action,
      data: new FormData(form),
      type: 'put',
      success: (data) => {
        this.updatePanes(data);
      }
    });
  }

  destroy(event) {
    this.request({
      url: event.params.url,
      type: 'delete',
      success: (data) => {
        this.updatePanes(data);
      }
    });
  }

  cancelNew(event) {
    if (this.hasRightPaneTarget) {
      this.rightPaneTarget.innerHTML = this.emptyTemplateTarget.innerHTML;
    }
  }

  // private

  request(options) {
    Rails.ajax({
      url: options.url,
      type: options.type,
      data: options.data,
      dataType: 'json',
      success: options.success
    });
  }

  updatePanes(data) {
    if (data.left_pane_html && this.hasLeftPaneTarget) {
      this.leftPaneTarget.innerHTML = data.left_pane_html;
    }
    if (data.right_pane_html && this.hasRightPaneTarget) {
      this.rightPaneTarget.innerHTML = data.right_pane_html;
    }
  }

  focusFirstInput() {
    if (this.hasRightPaneTarget) {
      const input = this.rightPaneTarget.querySelector('input[type=text]');
      if (input) {
        input.focus();
      }
    }
  }
}
